import React, { useEffect, useState } from 'react';
import { Menu, X, Printer } from 'lucide-react';
import { Button } from './ui/Button';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'Reviews',
    href: '#testimonials'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="flex justify-between items-center" data-id="element-121">
          {/* Logo */}
          <div className="flex items-center space-x-2" data-id="element-122">
            <div className={`p-2 rounded-lg ${isScrolled ? 'bg-blue-900 text-white' : 'bg-white text-blue-900'}`} data-id="element-123">
              <Printer className="h-6 w-6" data-id="element-124" />
            </div>
            <span className={`text-xl font-bold tracking-tight ${isScrolled ? 'text-blue-900' : 'text-blue-900 lg:text-white'}`} data-id="element-125">
              LIBERTY<span className="font-light" data-id="element-126">SCREEN</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-127">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-600 hover:text-blue-900' : 'text-gray-200 hover:text-white'}`} data-id="element-128">
                {link.name}
              </a>)}
            <Button variant={isScrolled ? 'primary' : 'primary'} size="sm" data-id="element-129">
              Get Quote Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-130">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 rounded-md ${isScrolled ? 'text-gray-900' : 'text-white'}`} data-id="element-131">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-132" /> : <Menu className="h-6 w-6" data-id="element-133" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-134">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-135">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-blue-900 hover:bg-gray-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-136">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-137">
              <Button className="w-full" size="lg" data-id="element-138">
                Get Quote Now
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}